import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/gauge.vue
var o = {
	name: "DtIconGauge",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--gauge"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Gauge",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M8.104 5.396a.5.5 0 0 1 0 .708l-1.75 1.75a.5.5 0 1 1-.708-.708l1.75-1.75a.5.5 0 0 1 .708 0Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1 7.3c0-2.698 2.246-4.8 5-4.8s5 2.102 5 4.8c0 .679-.168 1.343-.386 1.886a.5.5 0 1 1-.928-.372C9.869 8.357 10 7.821 10 7.3c0-2.102-1.754-3.8-4-3.8S2 5.198 2 7.3c0 .521.131 1.057.314 1.514a.5.5 0 1 1-.928.372C1.169 8.643 1 7.979 1 7.3Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=gauge.js.map